import { render, staticRenderFns } from "./P04.vue?vue&type=template&id=79deeef2&scoped=true"
import script from "./P04.ts?vue&type=script&lang=ts&external"
export * from "./P04.ts?vue&type=script&lang=ts&external"
import style0 from "./P04.vue?vue&type=style&index=0&id=79deeef2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79deeef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79deeef2')) {
      api.createRecord('79deeef2', component.options)
    } else {
      api.reload('79deeef2', component.options)
    }
    module.hot.accept("./P04.vue?vue&type=template&id=79deeef2&scoped=true", function () {
      api.rerender('79deeef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P04/P04.vue"
export default component.exports